import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  TextField,
} from "components/mui";
import { SendCANmail } from "api/canmail/CANmailAPI";
import { useNotificationProvider } from "hooks";
import { EMAIL_ADDRESS_REGEX } from "constants/canmail";

function TestSendModal({
  open,
  onClose,
  emailFrom,
  replyTo,
  subject,
  emailBody,
  attachments,
}) {
  const [toEmail, setToEmail] = useState("");
  const [sending, setSending] = useState(false);
  const { notifySuccess, notifyError } = useNotificationProvider();

  useEffect(() => {
    if (open) {
      setToEmail("");
      setSending(false);
    }
  }, [open]);

  // Validated with the composer's shared regex so a Test Send never rejects an address
  // that a real send would accept. Previously only emptiness was checked, so a typo'd
  // address was handed to the backend and failed there.
  const trimmedEmail = toEmail.trim();
  const isValidEmail = EMAIL_ADDRESS_REGEX.test(trimmedEmail);
  // Don't scold the user before they've typed anything.
  const showEmailError = trimmedEmail.length > 0 && !isValidEmail;

  const handleTestSend = async () => {
    if (!isValidEmail) return;

    setSending(true);
    try {
      await SendCANmail(
        0, // listId = 0 for individual email
        emailFrom, // from
        replyTo && replyTo.trim() !== "" ? replyTo : emailFrom, // reply_to
        subject, // subject
        emailBody, // email_contents
        attachments, // attachments
        trimmedEmail // to - recipient email for individual email
      );
      notifySuccess("Test email sent successfully");
    } catch (error) {
      console.error("[TestSendModal] Failed to send test email:", error);
      notifyError("Error sending test email, please try again");
    }
    setSending(false);
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Test Send</DialogTitle>
        <DialogContent sx={{ minWidth: 300 }}>
            <DialogContentText id="alert-dialog-description">
                This email will only be sent to the recipient below. 
            </DialogContentText>
          <TextField
            autoFocus
            label="To Email"
            type="email"
            fullWidth
            value={toEmail}
            onChange={(e) => setToEmail(e.target.value)}
            disabled={sending}
            error={showEmailError}
            helperText={showEmailError ? "Enter a valid email address." : " "}
            sx={{ mt: 2.5 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={sending} color="error">
            Cancel
          </Button>
          <Button
            onClick={handleTestSend}
            variant="contained"
            color="primary"
            disabled={sending || !isValidEmail}
          >
            Test Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TestSendModal;
